export const TOOLBAR_FONTS = [
  {
    label: 'Georgia',
    key: 'Georgia, serif',
    fontWeight: 400,
    props: {
      style: { fontFamily: 'Georgia, serif' },
      'data-item': 'btn-fontFamily-option',
    },
  },
  {
    label: 'Arial',
    key: 'Arial, sans-serif',
    fontWeight: 400,
    props: {
      style: { fontFamily: 'Arial, sans-serif' },
      'data-item': 'btn-fontFamily-option',
    },
  },
  {
    label: 'Courier New',
    key: 'Courier New, monospace',
    fontWeight: 400,
    props: {
      style: { fontFamily: 'Courier New, monospace' },
      'data-item': 'btn-fontFamily-option',
    },
  },
  {
    label: 'Times New Roman',
    key: 'Times New Roman, serif',
    fontWeight: 400,
    props: {
      style: { fontFamily: 'Times New Roman, serif' },
      'data-item': 'btn-fontFamily-option',
    },
  },
];

export const TOOLBAR_FONT_SIZES = [
  { label: '8', key: '8pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '9', key: '9pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '10', key: '10pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '11', key: '11pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '12', key: '12pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '14', key: '14pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '18', key: '18pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '24', key: '24pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '30', key: '30pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '36', key: '36pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '48', key: '48pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '60', key: '60pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '72', key: '72pt', props: { 'data-item': 'btn-fontSize-option' } },
  { label: '96', key: '96pt', props: { 'data-item': 'btn-fontSize-option' } },
];
